import React from "react"
import {
  Backdrop,
  BackdropProps,
  CircularProgress,
  CircularProgressProps,
  styled,
} from "@mui/material"

const SIZE = 45
const THICKNESS = 2

type Props = React.HTMLAttributes<HTMLDivElement> &
  BackdropProps & {
    dark?: boolean
  }

const SpinnerComponent = ({ dark, ...restProps }: Props) => {
  return (
    <StyledBackdrop dark={dark} {...restProps}>
      <Progress />
    </StyledBackdrop>
  )
}

const StyledBackdrop = styled(({ dark, ...props }: Props) => (
  <Backdrop {...props} />
))(({ theme, dark }) => ({
  color: theme.palette.primary.main,
  backgroundColor: dark
    ? "rgba(249, 250, 252, 0.85)"
    : "rgba(255, 255, 255, 0.85)",
  position: "absolute",
  zIndex: 10,
}))

export const Progress = styled((props: CircularProgressProps) => (
  <CircularProgress
    color="inherit"
    thickness={THICKNESS}
    size={SIZE}
    {...props}
  />
))(() => ({}))

SpinnerComponent.defaultProps = {
  dark: false,
}

export default SpinnerComponent
